import getCameraMaxWidth from '../getCameraMaxWidth/getCameraMaxWidth'

interface QualityDimensions {
  height: number
  width: number
}
export interface VideoConstraints {
  width?: {
    ideal: number
  }
  height?: {
    ideal: number
  }
  aspectRatio: number | {min: number, max: number} | { exact: number},
  resizeMode?: {
    exact: string
  }
  frameRate?: number
}

const quality1080: QualityDimensions = { height: 1080, width: 1920 }
const quality720: QualityDimensions = { height: 720, width: 1280 }
const quality360: QualityDimensions = { height: 360, width: 640 }
export const minQuality = quality360
export const aspectRatio = 1.777777778

/** Get the ideal quality of video for n number of presenters in a room */
function getIdealQuality (presenterCount: number): QualityDimensions {

  if (presenterCount <= 1) return quality720
  else if (presenterCount === 2) return quality720
  else return quality720

}

/** Check the ideal quality against the presenter's device capabilities and return the closest suitable quality */
function getViableQuality (idealQuality: QualityDimensions, maxCameraQuality: number): QualityDimensions | null {

  if (maxCameraQuality >= idealQuality.width) return idealQuality
  if (maxCameraQuality >= quality720.width) return quality720
  if (maxCameraQuality >= quality360.width) return quality360
  return null

}

function checkWidthSupported (camMaxWidth: number, curPresenterCount = 1): QualityDimensions | null {

  return getViableQuality(
    getIdealQuality(curPresenterCount),
    camMaxWidth
  )

}

/**
 * This function determines the ideal video constraints for a webRTC mediastream based off of the number of presenters
 * @param {number} presenterCount The current number of presenters in the room
 * @param {string} deviceId A specific device to check the constraints of
 * @return {object} An object containing the video constraints to pass to webRTC mediastream
 */
export default async function (presenterCount = 1, deviceId?: string, background = false): Promise<VideoConstraints> {

  let maxSupportedWidth

  try {

    maxSupportedWidth = await getCameraMaxWidth(deviceId)

  }
  catch (e) {

    return { 
      aspectRatio: {exact: aspectRatio}
    }

  }

  if (maxSupportedWidth === null) return { 
    aspectRatio: {exact: aspectRatio}
  }

  const dimensions = checkWidthSupported(maxSupportedWidth, presenterCount)
  const framerateUrl = window.location.search.split('framerate=')
  let frameRate = background ? 20 : 24

  if (framerateUrl.length > 1) {
    frameRate = background ? Number(framerateUrl[1].split(',')[0]) || 20 : Number(framerateUrl[1].split(',')[1]) || 24
  } 
  

  if (dimensions) {
    return {
      aspectRatio: {exact: aspectRatio},
      frameRate,
      width: { ideal: dimensions.width},
      height: { ideal: dimensions.height}
    }

  }
  else {

    const width = maxSupportedWidth
    const height = Math.ceil(width / aspectRatio)

    return {
      aspectRatio: {exact: aspectRatio},
      frameRate,
      width: { ideal: width },
      height: { ideal: height },
    }

  }

}
